import { render, staticRenderFns } from "./expiry-update-alert.vue?vue&type=template&id=401feff8"
import script from "./expiry-update-alert.vue?vue&type=script&lang=js"
export * from "./expiry-update-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports